import React from 'react';
import { Field, ErrorMessage, useField } from 'formik';

function ValidatedSelectField(props) {
    let { name } = props;
    const { label, readOnly, keyValueMap, errors, touched, fieldArray, fieldArrayIndex, onChange } = props;
    const [field] = useField(props);

    let className = "form-select";
    let showError = errors[name] && touched[name];

    if (fieldArray) {
        const fieldError = errors[fieldArray] && errors[fieldArray][fieldArrayIndex] && errors[fieldArray][fieldArrayIndex][name];
        const fieldTouched = touched[fieldArray] && touched[fieldArray][fieldArrayIndex] && touched[fieldArray][fieldArrayIndex][name];
        showError = fieldError && fieldTouched;

        name = `${fieldArray}.${fieldArrayIndex}.${name}`;
    }

    if (showError) {
        className += " is-invalid";
    }

    return (
        <div className="form-group">
            {label && <label htmlFor={name}>{label}</label>}
            <Field id={name} name={name} as="select" readOnly={readOnly} className={className} onChange={onChange ? e => onChange(e, field, props.values, props.setValues) : field.onChange}>
                {keyValueMap.map(kv =>
                    <option key={kv[0]} value={kv[0]}>{kv[1]}</option>
                )}
            </Field>
            <ErrorMessage name={name} component="div" className="invalid-feedback" />
        </div>
    )
}

export default ValidatedSelectField;
